
import './App.css';
import React from "react";
import Users from './Components/Users';


function App(){
  return(
    <div className="App">
      <h1>LGM VIP WEBDEV TASK 2 BY <a href="https://www.linkedin.com/in/garima-bisht-7b784014b/">GARIMA BISHT</a></h1>
      <Users/>
      
    </div>
    
  )
}

export default App;


